import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import { firebaseClientConfig } from './firebaseClientConfig';

const app = initializeApp(firebaseClientConfig);

export const auth = getAuth(app);

export const firestore = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});

export const getDb = () => getFirestore(app);
export const storageDb = () => getStorage(app);
